/**
 * 订单表单弹窗「基本信息」区块：订单分类与服务类型选择（含收支属性自动提示）
 */
import { Controller, type Control, type FieldErrors } from 'react-hook-form';
import type { OrderFormData } from '../../OrderFormSchema';
import type { OrderCategory, ServiceType } from '../../../../../types';
import { SectionHeader } from '../SectionHeader';
import { inp, lbl } from '../utils';

interface BasicInfoSectionProps {
  control: Control<OrderFormData>;
  errors: FieldErrors<OrderFormData>;
  form: OrderFormData;
  categories: OrderCategory[];
  serviceTypes: ServiceType[];
}

export function BasicInfoSection({ control, errors, form, categories, serviceTypes }: BasicInfoSectionProps) {
  return (
    /* ① 基本信息 */
    <div>
      <SectionHeader icon="ri-file-list-3-line" title="基本信息" color="bg-teal-50 text-teal-500" />
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className={lbl}>订单分类 <span className="text-rose-400">*</span></label>
          <Controller
            name="orderCategory"
            control={control}
            render={({ field }) => (
              <select
                {...field}
                className={inp(errors.orderCategory?.message)}
              >
                <option value="">请选择分类</option>
                {categories.map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
              </select>
            )}
          />
          {errors.orderCategory && <p className="text-xs text-rose-500 mt-1">{errors.orderCategory.message}</p>}
          {/* 自动收入/支出属性提示：仅根据分类名称字面量判断 */}
          {form.orderCategory && (() => {
            const isExpense = form.orderCategory.includes('支出');
            return (
              <div className={`mt-1.5 flex items-center gap-1.5 px-2 py-1 rounded-md text-xs font-medium ${isExpense ? 'bg-rose-50 text-rose-500' : 'bg-emerald-50 text-emerald-600'}`}>
                <div className="w-3.5 h-3.5 flex items-center justify-center shrink-0">
                  <i className={isExpense ? 'ri-subtract-line' : 'ri-add-line'} />
                </div>
                {isExpense ? '支出订单' : '收入订单'}
              </div>
            );
          })()}
        </div>
        <div>
          <label className={lbl}>服务类型 <span className="text-rose-400">*</span></label>
          <Controller
            name="serviceTypeId"
            control={control}
            render={({ field }) => (
              <select
                {...field}
                className={inp(errors.serviceTypeId?.message)}
              >
                <option value="">请选择类型</option>
                {serviceTypes.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
              </select>
            )}
          />
          {errors.serviceTypeId && <p className="text-xs text-rose-500 mt-1">{errors.serviceTypeId.message}</p>}
        </div>
      </div>
    </div>
  );
}